module.exports = __webpack_public_path__ + "media/flags/gs-ff23b3ec.svg";